module.exports = __webpack_public_path__ + "img/liberty-icon.679e2394.svg";